import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const LocationTracker = ({ children }: { children: React.ReactNode }) => {
    const location = useLocation();

    useEffect(() => {
        if(process.env.REACT_APP_GA_ENABLED === 'true' ){
            // Initialize Google Analytics
            ReactGA.initialize('G-C1S94S9HJK');
            // Track page views whenever the location changes
            ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
        }
    }, [location]);

    return <>{children}</>;
};

export default LocationTracker;